import { Link } from 'react-router-dom';
import { publicRegistry } from '@/i18n/dictionaries/publicRegistry';
import { pageLinksBeyond } from '@/features/common/layout/publicPageLinks';
import { usePublicPageLinks } from '@/features/common/layout/usePublicPageLinks';
import { useTranslation } from '@/i18n/useTranslation';
import { usePublicPageTitle } from '@/features/publicsite/usePublicPageTitle';
import { SITEMAP } from '@/features/publicsite/registry/sitemapEntries';

export function SitemapPage() {
  const { t, language } = useTranslation(publicRegistry);
  usePublicPageTitle(t('sitemapHeading'));
  // Pages an administrator published, after the ones named in code (T143).
  const pages = pageLinksBeyond(
    usePublicPageLinks(),
    SITEMAP.map(([to]) => to),
    language,
  );
  return (
    <section className="container section">
      <h1>{t('sitemapHeading')}</h1>
      <ul className="sitemap">
        {SITEMAP.map(([to, key]) => (
          <li key={to}>
            <Link to={to}>{t(key)}</Link>
          </li>
        ))}
        {pages.map((page) => (
          <li key={page.to}>
            <Link to={page.to} lang={page.lang}>
              {page.label}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
